/** Method key for the `@around` hook that mirrors `value` onto the ARIA value range (see `progress.ts`). */
export const measurable = Symbol('measurable')
